export var FEATURE_SUBFOLDERS = 'T36988_subfolders';
//# sourceMappingURL=features.js.map